import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _Promise from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/promise";

/*
 * 上传的文件对象 file文件对象，maxHeight文件的最大高度 maxWidth文件的最大宽度 quality代表质量 0.95的压缩比例与原始比例一致
 * */
import EXIF from "exif-js";

var canvasCompress = function canvasCompress(base64_photo) {
  var maxHeight = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 800;
  var maxWidth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 800;
  var quality = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0.8;
  return new _Promise(
  /*#__PURE__*/
  function () {
    var _ref = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(resolve, reject) {
      var img, canvas, context;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              // 文件读取
              // console.info("压缩之前的base64:", {
              //   base64_photo,
              //   length: base64_photo.length
              // });
              // 存放原始图片
              img = new Image();
              img.src = base64_photo; // 获取照片的拍摄方向
              // const orient = await getPhotoOrientation(file);
              // 缩放图片需要的canvas

              canvas = document.createElement("canvas");
              context = canvas.getContext("2d");

              img.onload = function () {
                var originWidth = this.width;
                var originHeight = this.height;
                var targetWidth = originWidth;
                var targetHeight = originHeight; // 图片尺寸的处理

                if (originWidth > maxWidth || originHeight > maxHeight) {
                  if (originWidth / originHeight > maxWidth / maxHeight) {
                    // 更宽，按照宽度限定尺寸
                    targetWidth = maxWidth;
                    targetHeight = Math.round(maxWidth * (originHeight / originWidth));
                  } else {
                    targetHeight = maxHeight;
                    targetWidth = Math.round(maxHeight * (originWidth / originHeight));
                  }
                } // 获取最小宽度


                var minWidth = targetWidth > targetHeight ? targetHeight : targetWidth; // canvas对图片进行缩放

                canvas.width = targetWidth;
                canvas.height = targetHeight; // 清除画布

                context.clearRect(0, 0, targetWidth, targetHeight); // 判断图片的方向是否正确，不正确则处理
                // if (orient && orient !== 1) {
                //   switch (orient) {
                //     case 6:
                //       // canvas.width = targetHeight;
                //       // canvas.height = targetWidth;
                //       context.rotate(Math.PI / 2);
                //       context.drawImage(
                //         img,
                //         0,
                //         -targetHeight,
                //         targetWidth,
                //         targetHeight
                //       );
                //       break;
                //     case 3:
                //       context.rotate(Math.PI);
                //       context.drawImage(
                //         img,
                //         -targetWidth,
                //         -targetHeight,
                //         targetWidth,
                //         targetHeight
                //       );
                //       break;
                //     case 8:
                //       // canvas.width = targetHeight;
                //       // canvas.height = targetWidth;
                //       context.rotate((3 * Math.PI) / 2);
                //       context.drawImage(
                //         img,
                //         -targetWidth,
                //         0,
                //         targetWidth,
                //         targetHeight
                //       );
                //       break;
                //   }
                // } else {
                //   // 图片压缩
                // }

                context.drawImage(img, 0, 0, targetWidth, targetHeight);
                var dataUrl = canvas.toDataURL("image/jpeg", quality); // console.info("压缩以后的base64:", {
                //   dataUrl,
                //   length: dataUrl.length
                // });

                resolve(dataUrl); // 成功之后删除创建出来的canvas元素
              };

              _context.next = 12;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
              reject(_context.t0);
              throw new Error(_context.t0);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 8]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
};

var mergePhoto = function mergePhoto(base64_photo_one, base64_photo_two) {
  return new _Promise(function (resolve, reject) {
    try {
      // 存放原始图片
      var img_one = new Image();
      img_one.src = base64_photo_one;
      var img_two = new Image();
      img_two.src = base64_photo_two; // 缩放图片需要的canvas

      var canvas = document.createElement("canvas");
      var context = canvas.getContext("2d");

      img_one.onload = function () {
        var originWidth = this.width;
        var originHeight = this.height;

        img_two.onload = function () {
          // canvas对图片进行缩放
          canvas.width = originWidth;
          canvas.height = originHeight + this.height; // 清除画布

          context.clearRect(0, 0, originWidth, originHeight + this.height);
          context.drawImage(img_one, 0, 0, originWidth, originHeight);
          context.drawImage(img_two, 0, originHeight, this.width, this.height);
          var dataUrl = canvas.toDataURL("image/jpeg");
          resolve(dataUrl);
        };
      };
    } catch (error) {
      reject(error);
    }
  });
};
/*
 * 获取照片的元信息（拍摄方向）
 * */


var getPhotoOrientation = function getPhotoOrientation(img) {
  return new _Promise(
  /*#__PURE__*/
  function () {
    var _ref2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2(resolve, reject) {
      var result;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return EXIF.getData(img, function () {
                result = EXIF.getTag(this, "Orientation");
                resolve(result);
              });

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }());
};

export { canvasCompress, mergePhoto };